export default "__VITE_ASSET__8AmH5IVh__"